import React, { Component } from 'react';
import HeaderElement from './HeaderElement';
import FooterElement from './FooterElement';
import FloatingMenu from './FloatingMenu';
import TutorialPopup from './TutorialPopup';

import _ from 'lodash';



export default class Tutorial extends Component {

	constructor(props) {
		super(props);
		this.state = { 
			background: 'green.png',		
		};
	}	


	render() {
		return (
			<div className="tutorial">
				<div className="bg-app" style={{backgroundImage:'url(img/background/' + this.state.background + ')'}} ></div>
				<HeaderElement />

						<div className="builder ">
							<div className={this.state.step === 1 ? "leftbar active" : "leftbar" } >
	                            <FloatingMenu name="Fondos" icon={<span className="btn-green"><i className="icon-fondos"></i></span>} color="green" btnMore={false}>
	                                
	                            </FloatingMenu>
	                            <FloatingMenu name="Suelos" icon={<span className="btn-green"><i className="icon-suelos"></i></span>} color="green" more={false}>
	                               
	  
	                            </FloatingMenu>
	                        </div>

							<div className={this.state.step === 2 ? "rightbar active" : "rightbar" } >	                        
	                            <FloatingMenu name="Construcciones" icon={<span className="btn-yellow"><i className="icon-contrucciones"></i></span>} color="yellow" btnMore={true}>
	                             
	                            </FloatingMenu>
	                            <FloatingMenu name="Naturaleza" icon={<span className="btn-yellow"><i className="icon-naturaleza"></i></span>} color="yellow" btnMore={true}>
	                             
	                            </FloatingMenu>
	                            {/*
	                            	<FloatingMenu name="Personajes" icon={<span className="btn-yellow"><i className="icon-personajes"></i></span>} color="yellow" btnMore={true}>
	                            
	                            	</FloatingMenu>
	                            */}
	                        </div>
							<div className="canvas"  >
								<div className="canvas-demo" ></div>
							</div>
							
						
						</div>
					
					<div className={'actions'}>						
						<a className="btn btn-brand" ><i className="icon-download" aria-hidden="true"></i> Guarda tu aventura</a>
					</div>
				<FooterElement />
				<TutorialPopup layout="tutorial" />		
		</div>
			
		);
	}
}



// WEBPACK FOOTER //
// ./src/Tutorial.js